var app = angular.module('bizmetryApp', [
  'ngMaterial',
  'ngRoute',
  'ngclipboard',
  'ui.tree',
  'rzModule'
]);

app.constant('CONFIG', {
  BIZMETRY_BACKEND_URL: '__BIZMETRY_BACKEND_URL__'
});

// ✅ Truncate filter
app.filter('truncate', function () {
  return function (input, limit) {
    if (!input) return '';
    if (!limit || input.length <= limit) return input;
    return input.substring(0, limit) + '...';
  };
});

// ✅ Arrancar monitor si ya hay sesión activa al recargar la app
app.run(['AuthService', function (AuthService) {
  if (sessionStorage.getItem("authTokenInfo")) {
    AuthService.startTokenMonitor();
  }
}]);

// 🔐 Verificar token antes de cambiar de ruta
app.run([
  '$rootScope', '$location', '$http', 'CONFIG', 'ConfigurationService',
  function ($rootScope, $location, $http, CONFIG, ConfigurationService) {

    ConfigurationService.loadAllConfig()
      .then(function (config) {
        $rootScope.configMap = config;
        console.log("✅ Global config loaded:", config);
      })
      .catch(function (err) {
        console.error("❌ Failed to preload config:", err);
      });

    $rootScope.$on('$routeChangeStart', function (event, next, current) {
      const tokenInfo = JSON.parse(sessionStorage.getItem("authTokenInfo") || "null");
      const token = tokenInfo?.access_token;
      const path = $location.path();
      const publicRoutes = [
        '/',
        '/login',
        '/landing',
        '/register',
        '/activate-account',
        '/activate-user',
        '/reset-password'        // 🔑 public — no requiere sesión
      ];

      if (token) {
        $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account/session/validate', {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function () {
          if (path === '/' || path === '/login') {
            console.log("✅ Token valid, redirecting to /home from", path);
            event.preventDefault();
            $location.path('/home');
          }
        }).catch(function (error) {
          console.warn("❌ Invalid token:", error);
          sessionStorage.removeItem("authTokenInfo");
          sessionStorage.removeItem("user");
          if (!publicRoutes.includes(path)) {
            event.preventDefault();
            $location.path('/login');
          }
        });
      } else if (!publicRoutes.includes(path)) {
        console.warn("🚨 No token, redirecting to /login");
        event.preventDefault();
        $location.path('/login');
      }
    });
  }
]);

// ✅ Rutas
app.config(['$routeProvider', '$locationProvider', '$qProvider', function ($routeProvider, $locationProvider, $qProvider) {

  $qProvider.errorOnUnhandledRejections(false);

  $routeProvider
    .when('/', {
      redirectTo: '/login'
    })
    .when('/landing', {
      redirectTo: '/login'
    })
    .when('/login', {
      templateUrl: 'login/login-dialog.html',
      controller: 'LoginController'
    })
    .when('/home', {
      templateUrl: 'home/home.html',
      controller: 'HomeController'
    })
    .when('/activate-account', {
      templateUrl: 'activation/activate-account.html',
      controller: 'AccountActivationController'
    })
    .when('/activate-user', {
      templateUrl: 'activation/activate-user.html',
      controller: 'UserActivationController'
    })
    .when('/register', {
      templateUrl: 'register/register.html',
      controller: 'RegisterController'
    })
    .when('/reset-password', {
      templateUrl: 'login/reset-password/reset-password-dialog.html',
      controller: 'ResetPasswordController'
    })
    .otherwise({
      redirectTo: '/'
    });

  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });
}]);

// ✅ Interceptor X-User headers
app.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push(['$q', function ($q) {
    return {
      request: function (config) {
        const user = JSON.parse(sessionStorage.getItem('user') || '{}');
        if (user.id) config.headers['X-User-Account-Id'] = user.id;
        if (user.email) config.headers['X-User-Id'] = user.email;
        return config;
      },
      responseError: function (rejection) {
        return $q.reject(rejection);
      }
    };
  }]);
}]);

// ✅ Interceptor de token
app.factory('AuthInterceptor', ['$q', function ($q) {
  return {
    request: function (config) {
      const tokenInfo = JSON.parse(sessionStorage.getItem("authTokenInfo") || "null");
      const token = tokenInfo?.access_token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    responseError: function (response) {
      return $q.reject(response);
    }
  };
}]);

app.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AuthInterceptor');
}]);

// ✅ API helper
app.service('ApiService', ['$http', 'CONFIG', function ($http, CONFIG) {
  this.getData = function (endpoint) {
    return $http.get(CONFIG.BIZMETRY_BACKEND_URL + endpoint)
      .then(response => response.data)
      .catch(error => {
        console.error("🚨 API Call Error:", error);
        throw error;
      });
  };
}]);